import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { HaldorBlockConsumer } from "@haldor/ui";
import { useTranslate } from "lib/translate";
import "./_AssessmentBlock.scss";
import AssessmentBlock from "./Blocks/AssessmentBlock";
var BlockConsumer = function BlockConsumer(props) {
  var _getFields;
  var translate = useTranslate();
  var getFields = function getFields() {
    var _props$assessment;
    var assessmentFeedback = ((_props$assessment = props.assessment) === null || _props$assessment === void 0 || (_props$assessment = _props$assessment.assessmentFeedbacks) === null || _props$assessment === void 0 ? void 0 : _props$assessment.length) > 0;
    var assessmentBlocks = props.fields.filter(function (s) {
      return s.resources.some(function (r) {
        return r.referenceType == 'assessmentonlyfeedback' && assessmentFeedback || Array.isArray(r.assessmentBlockPartRows);
      });
    });
    return assessmentBlocks.sort(function (a, b) {
      return a.sortorder - b.sortorder;
    }).map(function (field) {
      var label = translate('Teacher assessment');
      var ofType = assessmentBlocks.filter(function (block) {
        return block.assessmentType == field.assessmentType;
      });
      var foundIndex = ofType.findIndex(function (b) {
        return b.id == field.id;
      });
      field.title = label + ' ' + (foundIndex + 1);
      return field;
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "assessment-block"
  }, ((_getFields = getFields()) === null || _getFields === void 0 ? void 0 : _getFields.length) > 0 ? /*#__PURE__*/React.createElement("h3", null, translate("Assessment")) : null, /*#__PURE__*/React.createElement(HaldorBlockConsumer, _extends({
    plugins: [AssessmentBlock],
    translate: translate
  }, props, {
    fields: getFields()
  })));
};
export default BlockConsumer;